<template>
  <v-app>
    <CustomCursor />
    <router-view />
  </v-app>
</template>

<script>
import CustomCursor from "@/components/common/CustomCursor.vue";

export default {
  name: "App",
  components: {
    CustomCursor,
  },
};
</script>
